import React from "react";
import { useSelector } from "react-redux";

import ConfirmationModal from "@/components/atoms/modal/confirmation-modal";
import { RootState } from "@/store/store";

import { useCruiseContext } from "../../provider/cruise.provider";

type FormContentProps = {
  handleCruiseCoverModalConfirmButton: () => void;
  handleCruiseCoverModalBackButton: () => void;
};

function CruiseCoverModal({
  handleCruiseCoverModalConfirmButton,
  handleCruiseCoverModalBackButton,
}: Readonly<FormContentProps>) {
  const { magnoliaData, isCruiseModalOpen } = useCruiseContext();
  const {
    modalTitleText,
    modalSubTextOne,
    modalSubTextTwo,
    modalConfirmButtonText,
    modalCancelButtonText,
  } = magnoliaData.overlayArea[0];
  const quoteData = useSelector((state: RootState) => state.quote);
  const { attributes } = quoteData;
  const isCruise = attributes?.tripDetails?.goingOnCruise;
  return (
    <ConfirmationModal
      isOpen={isCruiseModalOpen}
      modalCancelBtnText={modalCancelButtonText ?? ""}
      modalConfirmBtnText={modalConfirmButtonText ?? ""}
      modalConfirmBtnClick={(val) => {
        if (val) {
          handleCruiseCoverModalConfirmButton();
        }
      }}
      modalSubText={isCruise ? modalSubTextTwo : modalSubTextOne}
      modalTitleText={modalTitleText ?? ""}
      modalCancelBtnClick={() => {
        handleCruiseCoverModalBackButton();
      }}
    />
  );
}

export default CruiseCoverModal;
